
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const EmptyExpenseState: React.FC = () => {
  return (
    <Card className="border border-gray-200">
      <CardContent className="p-6 text-center text-gray-500">
        No expenses added yet.
      </CardContent>
    </Card>
  );
};

export default EmptyExpenseState;
